import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';

export const useUIMode = (defaultMode = 'LIST') => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const uiMode = searchParams.get('mode') || defaultMode;
  const [objDetails, setObjDetails] = useState(
    (location.state && location.state.objDetails) ? location.state.objDetails : {}
  );

  useEffect(() => {
    if (location.state && location.state.objDetails) {
      setObjDetails(location.state.objDetails);
    } else if (uiMode === 'LIST') {
      setObjDetails({});
    }
  }, [location.state, uiMode]);

  const setUIMode = useCallback((newMode, details) => {
    if (newMode === 'LIST') {
      navigate(location.pathname, { replace: false });
    } else if (newMode === 'DETAILS' && details) {
      navigate(`${location.pathname}?mode=DETAILS`, {
        state: { objDetails: details }
      });
    } else {
      navigate(`${location.pathname}?mode=${newMode}`);
    }
  }, [navigate, location.pathname]);

  return { uiMode, objDetails, setObjDetails, setUIMode };
};
